import { mergeQueryKeys } from '@lukemorales/query-key-factory';

import { brandQueryKeys } from './repositories/brand/brand.constants';
import { campaignQueryKeys } from './repositories/campaign/campaign.constants';
import { campaignManagerQueryKeys } from './repositories/campaignManager/campaignManager.constants';
import { campaignPaymentsQueryKeys } from './repositories/campaignPayments/campaignPayments.constants';
import { productQueryKeys } from './repositories/product/product.constants';
import { settingsQueryKeys } from './repositories/settings/settings.constants';
import { guidelinesQueryKeys } from './repositories/guidelines/guidelines.constants';
import { guidelineRulesQueryKeys } from './repositories/guidelineRules/guidelineRules.constants';

export const queries = mergeQueryKeys(
  brandQueryKeys,
  campaignQueryKeys,
  campaignManagerQueryKeys,
  campaignPaymentsQueryKeys,
  productQueryKeys,
  settingsQueryKeys,
  guidelinesQueryKeys,
  guidelineRulesQueryKeys,
);
